// extracted by mini-css-extract-plugin
module.exports = {"warning_icon":"style_warning_icon__3_68L"};